import GetParentElementsRequestModelBase from '../_generated/modelBases/get-parent-elements-request-model-base';

export default class GetParentElementsRequestModel extends GetParentElementsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
